export const GoogleMapApiConfig = 'AIzaSyADspQexWHf7b_NLcvdaq8BFEJI5z6YgqU';